
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetail from "../pages/product-detail/page";
import SolicitarCotizacion from "../pages/solicitar-cotizacion/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/producto/:id",
    element: <ProductDetail />,
  },
  {
    path: "/solicitar-cotizacion",
    element: <SolicitarCotizacion />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
